import React from 'react'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import styles from './global.module.scss'

const Copyright = () => {
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      align="center"
      className={styles.copyrightRoot}
    >
      <span className={styles.copyrightBackground} />
      {'Copyright © '}
      <Link color="inherit" href="https://saddlesindia.com/">
        Saddles India
      </Link>{' '}
      {new Date().getFullYear()}
    </Typography>
  )
}

export default Copyright
